(function ($) {
  'use strict';

  var TRANSITION_TIMING = 250;
  var $searchIcon;
  var $mainNav = $('.nav-container');
  var $searchFormContainer = $('.cc--header .cc--search-form');
  var $searchInput = $searchFormContainer.find('input');
  var $logo = $('.transparent-header .cc--branding-header a svg path');
  var $hamburger = $('.header-buttons .mobile-menu-trigger');
  var $body = $('body');
  var labelOpen = 'Open Site Search';
  var labelClose = 'Close Site Search';
  var $horNav = $('.cc--horizontal-strip');

  var closeMenu = function () {
    $mainNav.css('style', 'none').fadeOut(TRANSITION_TIMING);
  };

  /**
   * Main functionality should be in an 'init' function
   */
  var initSearchForm = function () {
    $searchIcon = $(this);

    $searchFormContainer.attr({
      'aria-hidden': 'true',
      'aria-labelledby': 'search-dialog-title'
    });

    $searchFormContainer.find('h2').attr('id', 'search-dialog-title');

    function preventDefault(e) {
      e.preventDefault();
    }

    $searchIcon.on('click', function (e) {
      e.preventDefault();
      if($horNav.length) {
        $('.cc--horizontal-strip').attr('aria-hidden', 'true');
        $('.cc--horizontal-strip').attr('tabindex', '-1');
      }
      closeMenu();
      var $this = $(this);

      if (!$this.hasClass('is-active')) {
        openSearch();
        $this.addClass('is-active');
        $this.attr('aria-label', labelClose);
        $this.attr('aria-expanded', true);
        $('html').addClass('search-form-open main-menu-open');
        $logo.removeClass('white');
        $body.removeClass('transparent-header');
      } else {
        closeSearch();
        $this.removeClass('is-active');
        $this.attr('aria-label', labelOpen);
        $this.attr('aria-expanded', false);
        $('html').removeClass('search-form-open main-menu-open');
        $logo.addClass('white');

        if($horNav.length) {
          $('.cc--horizontal-strip').attr('aria-hidden', 'false');
          $('.cc--horizontal-strip').removeAttr('tabindex');
        }
      }

      $hamburger.removeClass('is-active');
      $hamburger.attr('aria-expanded', false);
      $hamburger.attr('aria-label', 'Open Site Navigation');
    });

    $searchFormContainer.on('keydown', function (ev) {
      // KEY_TAB
      // if (ev.keyCode === 9) {
      //   // ev.preventDefault();
      //   var inputs = $searchFormContainer
      //     .find('input, button')
      //     .filter(':visible')
      //     .not(':disabled');

      //   // redirect last tab to first input
      //   if (!ev.shiftKey) {
      //     if (inputs[inputs.length - 1] === ev.target) {
      //       ev.preventDefault();
      //       inputs.first().focus();
      //     }
      //   }
      //   // redirect first shift+tab to last input
      //   else {
      //     if (inputs[0] === ev.target) {
      //       ev.preventDefault();
      //       inputs.last().focus();
      //     }
      //   }
      // }

      // KEY_ESC
      if (ev.keyCode === 27) {
        ev.preventDefault();
        closeSearch();
        $searchIcon.removeClass('is-active');
      }
    });
  };

  var openSearch = function () {
    $searchFormContainer.addClass('is-open').attr('aria-hidden', 'false').fadeIn(100);
    $searchInput.first().focus();
  };

  var closeSearch = function () {
    $searchFormContainer.removeClass('is-open').attr('aria-hidden', 'true').fadeOut(100);
    $('#l--main-header').siblings().each(function (i, el) {
      el.inert = false;
    });
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   */
  window.DP.behaviors.searchForm = {
    attach: function (context) {
      $(context)
        .find('.cc--header .search-trigger-button')
        .once('searchForm')
        .each(function () {
          initSearchForm.apply(this);
        });
    },
  };
})(jQuery);
